/**
 * Custom image loader for Next.js Image component
 * Handles optimization for different CDN providers
 */
export default function imageLoader({ src, width, quality }) {
  // Amplience CDN - uses their Dynamic Media API
  if (src.includes('cdn.media.amplience.net')) {
    const url = new URL(src);
    // Amplience image transformation parameters
    // https://amplience.com/developers/docs/image-transformation/
    url.searchParams.set('w', width.toString());
    // Keep in sync with
    // AMPLIENCE_IMAGE_QUALITY in helpers/utils/amplience/imageLoader.ts.
    url.searchParams.set('qlt', (quality || 60).toString());
    url.searchParams.set('fmt', 'auto'); // Automatic format selection (WebP, AVIF when supported)
    return url.toString();
  }

  // Cloudinary CDN
  if (src.includes('res.cloudinary.com')) {
    const params = [
      `w_${width}`,
      `q_${quality || 'auto'}`,
      'f_auto', // Automatic format
      'c_limit', // Don't upscale
    ];
    // Insert transformation parameters after /upload/
    return src.replace('/upload/', `/upload/${params.join(',')}/`);
  }

  // AWS S3 - no built-in transformation, return as-is
  // Consider using CloudFront with image optimization if needed
  if (src.includes('s3-eu-west-1.amazonaws.com')) {
    return src;
  }

  // For relative URLs or other sources, return as-is
  return src;
}
